module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "czq-select",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": _vm.selectName
    },
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d2844b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/czqui/select/CZQSelect.vue
// module id = 552
// module chunks = 1